import Academics from "../components/Academics";

export default function AcademicsPage() {
  return (
    <section className="space-y-16 py-10">
      <Academics />
    </section>
  );
}
